/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_02_04_10_21
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TGetPlannedH2Amount { 
    facility_values_power_kg?: Array<number> | null;
    facility_values_energy_kg?: Array<number> | null;
    facility_values_power_kwh?: Array<number> | null;
    facility_values_energy_kwh?: Array<number> | null;
}

